import { render, staticRenderFns } from "./noticeAdd.vue?vue&type=template&id=de59dde4&scoped=true"
import script from "./noticeAdd.vue?vue&type=script&lang=js"
export * from "./noticeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de59dde4",
  null
  
)

export default component.exports